export default __webpack_public_path__ + "static/media/dot-shadow.5358eb79.svg";